const isValueDefined = (value: unknown) => {
  return !(value === '' || value === undefined)
}

export default isValueDefined
